import Typography from "@mui/material/Typography";
import Modal from "antd/lib/modal/Modal";
import Tag from "antd/lib/tag";

import { IconCloudStorm, IconAlertTriangle, IconUser } from "@tabler/icons-react";

import styles from "./confirmation-modal.module.css";

const TEST_MODE_EMAIL = process.env.REACT_APP_TEST_MODE_EMAIL;

export default function ConfirmationModal({ showConfirmModal, setShowConfirmModal, handleConfirmSubmit, isTestMode, selectedRegions, regionData }) {
    return (
        <Modal
        title={
          <div className={styles.modalConfirmHeader}>
            <IconCloudStorm size={24} style={{ color: '#034832' }} />
            <Typography variant="h6">Confirm Storm Strategies</Typography>
          </div>
        }
        visible={showConfirmModal}
        onOk={handleConfirmSubmit}
        onCancel={() => setShowConfirmModal(false)}
        width={800}
        className={styles.confirmModal}
        okText="Yes, send strategies"
        cancelText="No, review again"
        getContainer={false}
      >
        <div className={styles.confirmContent}>
          {isTestMode && (
            <div className={styles.confirmMessage}>
              <IconAlertTriangle size={20} />
              <Typography variant="body2" style={{ color: '#d48806' }}>
                Test Mode: All emails will be sent to {TEST_MODE_EMAIL}
              </Typography>
            </div>
          )}
          {selectedRegions.map((region) => {
            const data = regionData[region];
            if (!data?.selectedSites?.length || !data?.message) return null;
            return (
              <div key={region} className={styles.confirmSection}>
                <Typography variant="h6">{region}</Typography>
                <div className={styles.confirmValue}>
                  <div className={styles.confirmSites}>
                    {data.selectedSites.map((site) => (
                      <div
                        key={site.site_id}
                        className={styles.confirmSiteDetails}
                      >
                        <Tag className={styles.confirmSiteTag}>
                          {site.site_name}
                        </Tag>
                        <div className={styles.confirmContacts}>
                          {site.contacts?.length > 0 ? (
                            site.contacts.map((contact, idx) => (
                              <div
                                key={idx}
                                className={styles.confirmContact}
                              >
                                <IconUser size={14} />
                                {contact.first_name === 'Default' ? (
                                  <span style={{ color: '#d48806' }}>
                                    Fallback Contact
                                  </span>
                                ) : (
                                  <span>
                                    {contact.first_name}{' '}
                                    {contact.last_name}
                                  </span>
                                )}
                                <span className={styles.confirmEmail}>
                                  {contact.email}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div className={styles.confirmContact}>
                              <IconUser size={14} />
                              <span style={{ color: '#d48806' }}>
                                Fallback Contact
                              </span>
                              <span className={styles.confirmEmail}>
                                {TEST_MODE_EMAIL}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={styles.confirmSection}>
                  <Typography variant="h6">Message</Typography>
                  <div className={styles.confirmMessageBox}>
                    {data.message}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
    )
}